export default function OSWindow({ filename = 'untitled', onClose, children, className }) {
  return (
    <div className={`v3-os-window ${className || ''}`}>
      <div className="v3-os-window__bar">
        <span className="v3-os-window__filename">{filename}</span>
        <button
          type="button"
          className="v3-os-window__minimize"
          onClick={onClose}
          aria-label="Close"
        >
          –
        </button>
      </div>
      <div className="v3-os-window__body">{children}</div>
    </div>
  );
}
